/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InfantFiveYearOld } from './InfantFiveYearOld';
import {
    InfantFiveYearOldFromJSON,
    InfantFiveYearOldFromJSONTyped,
    InfantFiveYearOldToJSON,
} from './InfantFiveYearOld';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
} from './PaginationInfo';

/**
 * 
 * @export
 * @interface InfantFiveYearOldPagination
 */
export interface InfantFiveYearOldPagination {
    /**
     * 
     * @type {Array<InfantFiveYearOld>}
     * @memberof InfantFiveYearOldPagination
     */
    data?: Array<InfantFiveYearOld>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof InfantFiveYearOldPagination
     */
    meta?: PaginationInfo;
}

/**
 * Check if a given object implements the InfantFiveYearOldPagination interface.
 */
export function instanceOfInfantFiveYearOldPagination(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InfantFiveYearOldPaginationFromJSON(json: any): InfantFiveYearOldPagination {
    return InfantFiveYearOldPaginationFromJSONTyped(json, false);
}

export function InfantFiveYearOldPaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): InfantFiveYearOldPagination {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(InfantFiveYearOldFromJSON)),
        'meta': !exists(json, 'meta') ? undefined : PaginationInfoFromJSON(json['meta']),
    };
}

export function InfantFiveYearOldPaginationToJSON(value?: InfantFiveYearOldPagination | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(InfantFiveYearOldToJSON)),
        'meta': PaginationInfoToJSON(value.meta),
    };
}

